'use client'
import RadioGroup from '@/src/components/common/RadioGroup'
import styles from '../OnboardingForm.module.scss'
import bgimage from './bgimage.svg'
import bgimageMobile from './bgimage-mobile.svg'
import imgStarted from './icons/started.svg'
import imgClock from './icons/clock.svg'
import imgSwitch from './icons/switch.svg'
import imgPackage from './icons/package.svg'
import imgBriefcase from './icons/briefcase.svg'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'
import Img from '@/src/components/common/Img/Img'

export default function HomeCareStageForm() {
  const [onboardingData] = useState(readStoredData())

  const options = [
    {
      icon: imgStarted.src,
      value: 'getting_started',
      display: (
        <div>
          <div>{`I’m just getting started`}</div>
          <div className={styles.subheading}>
            {`I have not registered for a Support at Home funding and I am looking for assistance`}
          </div>
        </div>
      ),
    },
    {
      icon: imgClock.src,
      value: 'wait_funding',
      display: (
        <div>
          <div>{`I’m waiting for my Support at Home funding`}</div>
          <div className={styles.subheading}>
            {`I have been assessed and I am waiting for funding`}
          </div>
        </div>
      ),
    },
    {
      icon: imgSwitch.src,
      value: 'switch_provider',
      display: (
        <div>
          <div>{`I’m looking to switch service providers`}</div>
          <div className={styles.subheading}>
            {`I currently have a package and I am looking to change my Support at Home provider`}
          </div>
        </div>
      ),
    },
    {
      icon: imgPackage.src,
      value: 'with_homecare_package',
      display: (
        <div>
          <div>{`I have my Support at Home funding`}</div>
          <div className={styles.subheading}>
            {`I’ve been assigned funding for a Support at Home funding`}
          </div>
        </div>
      ),
    },
    { icon: imgBriefcase.src, value: 'employment', display: 'I’m looking for work' },
  ]

  const name = 'homecare_stage'
  return (
    <>
      <div>
        <h3
          className={styles.heading}>{`Which stage of the Support at Home process are you in?`}</h3>
        No matter where you’re at, we’ll help guide you with support that is tailored to your needs.
        <RadioGroup
          required
          options={options}
          name={name}
          value={(onboardingData.data?.[name] || '') as string}
          className={styles.iconOptions}
        />
      </div>
      <div>
        <Img src={bgimage.src} className={styles.desktop} />
        <Img src={bgimageMobile.src} className={styles.mobile} />
      </div>
    </>
  )
}
